'use strict';
var svaneTvis = svaneTvis || {};
svaneTvis.shopselector = svaneTvis.shopselector || new function () {
    this.init = function () {
        // const shops = document.querySelectorAll('.js-store-list__link');
        // for (let i = 0; i < shops.length; i++) {
        //     shops[i].addEventListener('click', function (e) {
        //         var target = e.target || e.srcElement,
        //             text = target.textContent || target.innerText;
        //         setCookie("SelectedShop", text.trim(), 7);
        //     });
        // }

        // Shop selector overlay
        const shopsOverlay = document.querySelectorAll('.js-select-store-input');
        for (let u = 0; u < shopsOverlay.length; u++) {
            shopsOverlay[u].addEventListener('click', function (e) {
                var id = e.target.getAttribute('data-shop-id');
                setCookie("SelectedShop", id, 7);
            });
        }
    };
}();

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}